import { gql } from "graphql-tag";
import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const workWithUs = pageType => gql`
  fragment ${pageType} on Work_with_usSlicesWork_with_us {
    type
    label
    variation {
      variation: __typename
      ... on Work_with_usSlicesWork_with_usDefault {
        primary {
          title
          description
        }
      }
      ... on Work_with_usSlicesWork_with_usTitlebanner {
        primary {
          title_image
        }
      }
      ... on Work_with_usSlicesWork_with_usCalltoaction {
        primary {
          subtitle
          titleimage
          button_label
          section_height_desktop
          section_height_mobile
          titleimage
          image
          button_link {
            ...documentLink
            ...externalLink
          }
        }
      }
      ... on Work_with_usSlicesWork_with_usAboutus {
        primary {
          title
          description
          image
          paragraph
        }
        items {
          paragraph
        }
      }
      ... on Work_with_usSlicesWork_with_usImagebanner {
        primary {
          title
          image
        }
        items {
          subtitle
          subtitle_image
          paragraph
        }
      }
      ... on Work_with_usSlicesWork_with_usMediagridwithbgcolor {
        primary {
          title
          description
          background_color
        }
        items {
          subtitle
          paragraph
          image
        }
      }
      ... on Work_with_usSlicesWork_with_usMediagridwithbgimage {
        primary {
          title
          description
          background_image
          title_image
        }
        items {
          heading
          paragraph
          image
        }
      }
      ... on Work_with_usSlicesWork_with_usMediagridwithheading {
        primary {
          title
          description
        }
        items {
          subtitle
          heading
          paragraph
          image
        }
      }
      ... on Work_with_usSlicesWork_with_usMediagridwithbanner {
        primary {
          title
          description
          subtitle
            titleimage
            button_label
            section_height_desktop
            section_height_mobile
            image
            justify_content
            button_link {
              ...documentLink
              ...externalLink
            }
        }
        items {
          subtitle
          image
          category_link {
            ...documentLink
            ...externalLink
          }
        }
      }
    }
  }
${documentLink}
${externalLink}
`;
